import { Input } from '@crono-one/design-system';
import { useCommittableDraft } from 'hooks/useCommittableDraft';

export interface CommittableInputProps {
  value: string;
  type: 'text' | 'number';
  placeholder: string;
  disabled: boolean;
  onCommit: (value: string) => void;
}

const CommittableInput = ({
  value,
  type,
  placeholder,
  disabled,
  onCommit,
}: CommittableInputProps) => {
  const { setDraft, commitDraft } = useCommittableDraft(value, onCommit);

  return (
    <Input
      key={value}
      dsSize="sm"
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      defaultValue={value}
      onChange={(ev) => setDraft(ev.target.value)}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter') {
          const target = ev.target as HTMLInputElement;
          ev.preventDefault();
          ev.stopPropagation();
          commitDraft(target.value);
        }
      }}
      onBlur={(ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        commitDraft(ev.target.value);
      }}
    />
  );
};

export default CommittableInput;
